import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import Modal from "./Modal";
import { useTranslation } from "react-i18next";

const Signature = ({ setSignature }) => {
  const { t, i18n } = useTranslation("consentform");

  const currentLang = i18n.language || "he";
  const dir = currentLang === "he" || currentLang === "ar" ? "rtl" : "ltr";

  const [showModal, setShowModal] = useState(false);
  const [dataSign, setDataSign] = useState(false);
  const [imageURL, setImageURL] = useState(null);

  const sign = useRef(null);

  function clearSign() {
    sign.current.clear();
    setDataSign(false);
    setSignature(false);
  }

  function save() {
    const signatureImage = sign.current.getTrimmedCanvas().toDataURL("image/png");

    setImageURL(signatureImage);
    setSignature(signatureImage);
    setShowModal(false);
  }

  const setSignatureOnChange = () => {
    const dataURL = sign.current.toDataURL();
    setDataSign(dataURL);
  };

  return (
    <div className="w-full" dir={dir} lang={currentLang}>
      <div
        className="w-full h-[200px] bg-LightBlue border-[0.5px] border-dashed border-midnight rounded-md flex justify-center items-center cursor-pointer"
        onClick={() => {
          setShowModal(true);
          setDataSign(false);
        }}
      >
        {imageURL ? (
          <img className="max-h-[200px]" src={imageURL} alt={t("signature.previewAlt")} />
        ) : (
          <p className="w-full text-center font-bold">
            {t("signature.clickToSign")}
          </p>
        )}
      </div>

      {showModal && (
        <Modal showModal={showModal} setShowModal={setShowModal}>
          <div
            className="w-full text-center text-sm font-heebo"
            dir={dir}
            lang={currentLang}
          >
            <p className="font-bold">{t("signature.title")}</p>
            <p>{t("signature.instruction")}</p>
          </div>

          <SignatureCanvas
            canvasProps={{
              className:
                "w-full h-[200px] bg-LightBlue border my-2 border-MidBlue rounded-[4px]",
            }}
            ref={sign}
            onEnd={setSignatureOnChange}
          />

          <div className="w-full flex justify-between font-heebo font-bold text-lg">
            {dataSign ? (
              <button
                type="button"
                className="px-8 w-fit rounded-md text-white bg-PraimeryBlue"
                onClick={save}
              >
                {t("signature.save")}
              </button>
            ) : (
              <button
                type="button"
                className="px-8 w-fit rounded-md bg-Grey100 text-Grey300"
                disabled
              >
                {t("signature.save")}
              </button>
            )}

            {dataSign ? (
              <button
                type="button"
                className="p-4 w-fit rounded-md bg-LightBlue"
                onClick={clearSign}
              >
                {t("signature.clear")}
              </button>
            ) : (
              <button
                type="button"
                className="p-4 w-fit rounded-md bg-Grey100 text-Grey300"
                disabled
              >
                {t("signature.clear")}
              </button>
            )}
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Signature;